module.exports = __webpack_public_path__ + "static/media/chat.acc3182b.png";